<template>
  <div>
    <iMineTemplate
      :page-title="pageTitle"
      :actived-parent-key="activedParentKey"
      :actived-key="activedKey"
    >
      <template #rightContent>
        <div class="box">
          <!-- 退款编号，退款基础信息 -->
          <div class="flex-row">
            <div class="flex-row-column">
              退款编号：{{ detailData ? detailData.AfterSaleNo : '' }}
            </div>
            <div class="flex-row-slogan">
              <div>
                <img
                  style="width: 50px;"
                  :src="
                    require(detailData.RefundSateteName == '拒绝退款'
                      ? '../../assets/fail.png'
                      : '../../assets/success.png')
                  "
                >
              </div>
              <div>
                <label
                  :style="{
                    color:
                      detailData.RefundSateteName == '拒绝退款'
                        ? '#FF3939'
                        : '#0F6EE9',
                    paddingBottom:
                      detailData.RefundSateteName == '拒绝退款' ? '0px' : '10px'
                  }"
                >{{ detailData.RefundSateteName }}</label>
                <p
                  v-if="detailData.RefundSateteName == '拒绝退款'"
                  style="margin: 0 0 10px; color: #FF3939;"
                >
                  {{ detailData.AuditNote }}
                </p>
              </div>
              <div class="top-desc">
                <div class="desc">
                  <span>
                    <span
                      style="
                        display: inline-block;
                        width: 290px;
                        text-align: right;
"
                    >退款金额：</span>￥{{
                      _getPriceArray(
                        Number(
                          detailData ? detailData.TotalRefundAmount : 0
                        ).toFixed(2)
                      )[0]
                    }}.{{
                      _getPriceArray(
                        Number(
                          detailData ? detailData.TotalRefundAmount : 0
                        ).toFixed(2)
                      )[1]
                    }}
                  </span>
                </div>
                <div class="desc">
                  <span
                    style="
                      display: inline-block;
                      width: 290px;
                      text-align: right;
"
                  >退款路径：</span>{{
                    detailData && detailData.AfterSalePaymentState === 1
                      ? '原路退款'
                      : '线下退款'
                  }}
                </div>
                <div class="desc">
                  <span
                    style="
                      display: inline-block;
                      width: 290px;
                      text-align: right;
"
                  >退回优惠券：</span><img
                    v-if="detailData && detailData.HasCoupon"
                    width="16px"
                    height="14px"
                    :src="require('../../assets/order/ticket.png')"
                    alt=""
                  >{{
                    detailData &&
                      detailData.HasCoupon &&
                      detailData.CouponInfo.Name
                      ? detailData.CouponInfo.Name
                      : '无优惠券'
                  }}
                </div>
              </div>
              <!-- <div>
								<span>
									退款金额： ￥{{ _getPriceArray(Number(detailData ? detailData.TotalRefundAmount : 0).toFixed(2))[0] }}.{{
										_getPriceArray(Number(detailData ? detailData.TotalRefundAmount : 0).toFixed(2))[1]
									}}
								</span>
							</div>
							<div>
								<p>退款时间：{{ detailData ? detailData.CreateTime : '' }}</p>
							</div> -->
            </div>
          </div>
          <!-- 退款编号，退款基础信息 end -->

          <!-- 商品信息 -->
          <div class="card pl20 pt20 pr20 border mb20 bgfff i_radius pb40">
            <div class="card-t">
              商品信息
              <span style="margin-left: 350px;">单价</span>
              <span style="margin-left: 94px;">数量</span>
              <span style="margin-left: 92px;">小计</span>
              <span style="margin-left: 92px;">实付</span>
            </div>
            <div class="card-i" style="padding: 0;">
              <div
                v-for="(goods, key) in GoodsList"
                :key="key+'a'"
              >
                <ProductDetails :goods="goods" :type="goods.ActivityCode" :gift-type="0" />
              </div>
              <!-- 换购 -->
              <div
                v-for="(goods,key) in ExchangeList"
                :key="key+'b'"
              >
                <ProductDetails :goods="goods" :gift-type="2" />
              </div>
              <!-- 赠品 -->
              <div
                v-for="(goods,key) in GiftList"
                :key="key+'c'"
              >
                <ProductDetails :goods="goods" :gift-type="1" />
              </div>
            </div>
          </div>
          <!-- 商品信息 end -->

          <!-- 原订单信息，退款信息 -->
          <div class="flex-row">
            <div class="flex-table-row">
              <div class="flex-list list-l">
                <div class="flex-row-column">退款信息</div>
              </div>
              <div class="flex-list list-r">
                <div class="flex-row-column">订单信息</div>
              </div>
            </div>
            <div class="flex-table-row">
              <div class="flex-list list-l">
                <ul>
                  <template
                    v-if="
                      detailData.PayMode == '线下退款' ||
                        detailData.RefundSateteName == '拒绝退款'
                    "
                  >
                    <li>
                      <span>银行名称</span>
                      {{
                        detailData.OrderRefundApply
                          ? detailData.OrderRefundApply.AccountName
                          : ''
                      }}
                    </li>
                    <li>
                      <span>银行卡号</span>
                      {{
                        detailData.OrderRefundApply
                          ? detailData.OrderRefundApply.BankNo
                          : ''
                      }}
                    </li>
                    <li>
                      <span>开户行名称</span>
                      {{
                        detailData.OrderRefundApply
                          ? detailData.OrderRefundApply.BankName
                          : ''
                      }}
                    </li>
                  </template>
                  <template v-if="detailData.RefundSateteName == '已退款'">
                    <li>
                      <span>退款时间</span>
                      {{ detailData ? detailData.AuditTime : '' }}
                    </li>
                    <li>
                      <span>退款编号</span>
                      {{ detailData ? detailData.AfterSaleNo : '' }}
                    </li>
                  </template>
                  <li
                    v-if="
                      detailData.PayMode == '线下退款' &&
                        detailData.OrderRefundApply &&
                        detailData.OrderRefundApply.RefundVoucher
                    "
                  >
                    <span>退款凭证</span>
                    <img
                      class="img"
                      style="
                        margin-right: 15px;
                        height: 44px;
                        vertical-align: middle;
"
                      :src="
                        detailData.OrderRefundApply
                          ? detailData.OrderRefundApply.RefundVoucher
                          : ''
                      "
                    >
                    <span
                      class="link"
                      @click="
                        handlePreview(
                          detailData.OrderRefundApply
                            ? detailData.OrderRefundApply.RefundVoucher
                            : ''
                        )
                      "
                    >查看大图</span>
                    <!-- {{ detailData ? detailData.AfterSaleNotes : '' }} -->
                  </li>
                  <!-- <li>
										<span>退款金额</span>
										￥{{ _getPriceArray(Number(detailData ? detailData.TotalRefundAmount : 0).toFixed(2))[0] }}.{{
											_getPriceArray(Number(detailData ? detailData.TotalRefundAmount : 0).toFixed(2))[1]
										}}
									</li>
									<li>
										<span>退款原因</span>
										{{ detailData ? detailData.AfterSaleNotes : '' }}
									</li>
									<li v-if="detailData && detailData.AfterSalePaymentState === 1">
										<span>退款路径</span>
										原路退款
									</li>
									<li v-else>
										<span>退款路径</span>
										线下退回
									</li>
									<li>
										<span>退款时间</span>
										{{ detailData ? detailData.CreateTime : '' }}
									</li>
									<li>
										<span>退款优惠券</span>
										{{ detailData && detailData.HasCoupon && detailData.CouponInfo.Name ? detailData.CouponInfo.Name : '无优惠券' }}
									</li> -->
                </ul>
              </div>
              <div class="flex-list list-r">
                <ul>
                  <li><span>&nbsp;&nbsp;&nbsp;</span></li>
                  <li>
                    <span>原订单信息</span>
                    <a @click="herfDetail">查看原订单</a>
                  </li>
                  <li>
                    <span>支付方式</span>
                    {{
                      detailData
                        ? detailData.OrderInfo.PayMode
                          ? detailData.OrderInfo.PayMode
                          : '线下退款'
                        : '线下退款'
                    }}
                  </li>
                  <li>
                    <span>支付金额</span>
                    ￥{{
                      _getPriceArray(
                        Number(
                          detailData
                            ? detailData.OrderInfo.TotalAmountPaidActual
                            : 0
                        ).toFixed(2)
                      )[0]
                    }}.{{
                      _getPriceArray(
                        Number(
                          detailData
                            ? detailData.OrderInfo.TotalAmountPaidActual
                            : 0
                        ).toFixed(2)
                      )[1]
                    }}
                  </li>
                  <li>
                    <span>下单时间</span>
                    {{ detailData ? detailData.OrderInfo.CreateTime : '' }}
                  </li>
                  <li>
                    <span>订单编号</span>
                    {{ detailData ? detailData.OrderInfo.OrderNo : '' }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 原订单信息，退款信息 end -->
        </div>
      </template>
    </iMineTemplate>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import { LinkTypeCode } from '@/dictionary/base.js'
import { BaseMixin } from '../../mixins/BaseMixin.js'
import ProductDetails from './components/ProductDetails'
export default {
  name: 'OrderRefundDetails',
  components: {
    ProductDetails
  },
  mixins: [BaseMixin],
  data() {
    return {
      pageTitle: ['我的账户', '我的订单'],
      activedParentKey: 2,
      activedKey: 23,
      // 退款订单编号
      refundOrderId: '',
      // 订单详情数据
      detailData: '',
      GoodsList: [],
      ExchangeList: [],
      GiftList: [],
      // 订单详情数据(商品明细)
      goodsData: ''
    }
  },
  created() {
    // 获取并保存退款单ID
    this.refundOrderId = this.$route.query.orderId
      ? (this.refundOrderId = this.$route.query.orderId)
      : (this.refundOrderId = '')
    // 根据ID获取退款订单详情
    this.getDetail()
    // 根据ID获取退款订单详情(商品明细)
    this.getGoods()
  },
  methods: {
    handlePreview(url) {
      ImagePreview({ images: [url], closeable: true })
    },
    /**
     * 根据ID获取退款订单详情
     * xuzhongqi
     * 2020.12.16
     */
    async getDetail() {
      this.$hys.openLoading()
      const res = await this.getAction(
        '/api_aftersale/AfterSaleDocment/Detail',
        {
          id: this.refundOrderId
        }
      )
      this.$hys.clearLoading()
      if (res.IsSuccess && res.Data) {
        this.getGoodsDtoV2(res.Data.OrderId, res.Data.Goods.map(val => val.GoodsSkuId))
        this.detailData = res.Data
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
    },
    /**
     * 根据ID获取退款订单详情(商品明细)
     * xuzhongqi
     * 2020.12.16
     */
    async getGoods() {
      this.$hys.openLoading()
      const res = await this.getAction(
        '/api_aftersale/AfterSaleDocment/Goods',
        {
          id: this.refundOrderId
        }
      )
      this.$hys.clearLoading()
      if (res.IsSuccess && res.Data) {
      //  this.getGoodsDtoV2(res.Data.map(val => val.ProductSKUId))
        this.goodsData = res.Data
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
    },
    async getGoodsDtoV2(OrderId, GoodsIds) {
      this.$hys.openLoading()
      const res = await this.postAction(
        '/api_order/Orders/QueryOrderSkus',
        {
          OrderId,
          GoodsIds
        }
      )
      this.$hys.clearLoading()
      if (res.IsSuccess && res.Data) {
        const { GoodsList, GiftList, ExchangeList } = res.Data
        this.GoodsList = GoodsList
        this.GiftList = GiftList
        this.ExchangeList = ExchangeList
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
    },
    /**
     * 查看原订单详情
     * xuzhongqi
     * 2020.12.16
     */
    herfDetail() {
      this.$router.push({
        path: 'OrderDetails',
        query: {
          orderId: this.detailData.OrderInfo.Id
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url('~@/styles/orderRefundDetails.less');

.top-desc {
  margin: 0 auto;
  border-radius: 4px;
  padding: 15px;
  width: 600px;
  background: #F8F8F8;

  .desc {
    margin-bottom: 6px;
    font-size: 14px !important;
    text-align: left;
    color: #222222 !important;
  }
}

</style>
